const DEV_URL = 'https://api.octapharma.bakasable.fr/api';

export const API_URL = DEV_URL;

export const TOOL_ID = '6008342d694b5b3e188cda33';
